<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
            <v-card>
                <v-card-title class="success white--text py-3">
                    <v-icon dark class="mr-2">check_circle</v-icon>
                    {{ $t("printing.agent_created_title") }}
                </v-card-title>

                <v-card-text class="pt-5" style="max-height: 70vh;">
                    <v-alert type="warning" text dense class="mb-4 body-2">
                        {{ $t("printing.agent_key_warning") }}
                    </v-alert>

                    <div class="key-display pa-3 rounded mb-3">
                        <div class="overline grey--text text--darken-1 mb-1">
                            {{ $t("printing.agent_key") }}
                        </div>
                        <div class="d-flex align-center">
                            <code class="key-value flex-grow-1 mr-2">{{
                                rawKey
                            }}</code>
                            <v-btn
                                icon
                                small
                                :color="copied ? 'success' : 'grey darken-1'"
                                @click="copyToClipboard"
                            >
                                <v-icon small>{{
                                    copied ? "check" : "content_copy"
                                }}</v-icon>
                            </v-btn>
                        </div>
                    </div>

                    <div class="body-2 mb-4">
                        {{ $t("printing.agent_key_instructions") }}
                    </div>

                    <!-- Connection status: polls until the agent's first call -->
                    <v-alert
                        v-if="connected"
                        type="success"
                        text
                        dense
                        class="body-2"
                    >
                        {{ $t("printing.agent_connected") }}
                    </v-alert>
                    <v-alert v-else type="info" text dense class="body-2">
                        <v-progress-circular
                            indeterminate
                            size="14"
                            width="2"
                            class="mr-2"
                        ></v-progress-circular>
                        {{ $t("printing.agent_waiting") }}
                    </v-alert>
                </v-card-text>

                <v-card-actions class="pa-4 pt-2">
                    <v-spacer></v-spacer>
                    <v-btn outlined rounded color="primary" @click="closeDialog">{{
                        $t("printing.done")
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { PRINT_AGENTS_QUERY } from "@/graphql/printing.js";

export default {
    name: "print-agent-created-dialog",
    props: ["dialog", "rawKey", "agentId"],
    data() {
        return {
            copied: false,
            connected: false,
            pollTimer: null
        };
    },
    watch: {
        dialog(val) {
            if (val) {
                this.copied = false;
                this.connected = false;
                this.startPolling();
            } else {
                this.stopPolling();
            }
        }
    },
    beforeDestroy() {
        this.stopPolling();
    },
    methods: {
        startPolling() {
            this.stopPolling();
            this.pollTimer = setInterval(this.checkConnection, 5000);
        },
        stopPolling() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
        },
        async checkConnection() {
            if (!this.agentId) return;
            try {
                const response = await this.$apollo.query({
                    query: PRINT_AGENTS_QUERY,
                    fetchPolicy: "network-only"
                });
                const agent = (response.data.printAgents || []).find(
                    item => item.id === this.agentId
                );
                if (agent && agent.lastUsedAt) {
                    this.connected = true;
                    this.stopPolling();
                    this.$emit("agent-connected");
                }
            } catch (error) {
                console.log("print agent poll error: ", error);
            }
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.rawKey).then(() => {
                this.copied = true;
                this.$store.dispatch("snackbar/showMessage", {
                    color: "success",
                    message: this.$t("printing.copied")
                });
            });
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        }
    }
};
</script>

<style scoped>
.key-display {
    background-color: #263238;
    border: 1px solid #37474f;
}
.key-value {
    font-family: "Roboto Mono", "Courier New", monospace;
    font-size: 13px;
    color: #80cbc4;
    word-break: break-all;
    line-height: 1.5;
    background: transparent;
    padding: 0;
}
</style>
